<template>
    <kgr-form-scaffold
        :with-primary-buttons="false"
        @backBtnClicked="redirectToOverview"
    >
        <kgr-member-dog-files-data-provider
            v-slot="filesScope"
            :member-id="memberId"
            :callback="onRelationsLoaded"
        >
            <div class="animated fadeIn">
                <h1 class="kgr-headline kgr-headline--h2 kgr-headline--text kgr-headline--firstInText">
                    {{ $t('Dateien zugehöriger Hunde') }}
                </h1>
                <kgr-file-table
                    :relations="filesScope.data"
                />
            </div>
        </kgr-member-dog-files-data-provider>
    </kgr-form-scaffold>
</template>

<script>
import FileTable from '../../components/common/file/FileTable.vue';
import FormScaffold from '../../components/common/form/FormScaffold.vue';
import MemberDogFilesDataProvider from '../../components/data-provider/MemberDogFilesDataProvider.vue';

export default {
    components: {
        'kgr-form-scaffold': FormScaffold,
        'kgr-file-table': FileTable,
        'kgr-member-dog-files-data-provider': MemberDogFilesDataProvider,
    },
    props: {
        overviewUrl: {
            type: String,
            required: true
        },
        memberId: {
            type: Number,
            required: true,
        },
        clubId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            relations: []
        };
    },
    computed: {
    },
    watch: {
    },
    created() {
    },
    methods: {
        onRelationsLoaded(relations) {
            this.relations = relations;
        },
        redirectToOverview() {
            window.location = this.overviewUrl;
        },
    }
}
</script>

<style scoped lang="scss" rel="stylesheet/scss"></style>
